/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	// メディアクエリ
	var mql = window.matchMedia('screen and (max-width: 768px)');
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	// resizing
	
	(0, _module.showMovie)();
	
	// headerToggle
	
	(0, _module.headerToggle)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	$(window).on('load', function () {
	  setTimeout(function () {
	    (0, _module.scrollAnimation)();
	  }, 100);
	});
	$(window).on('scroll', function () {
	  (0, _module.scrollAnimation)();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 768;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	// preload
	var preload = function preload() {
	  var timer = 0;
	  $(window).on('load', function () {
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("preload");
	    }, 100);
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    var resizeWidth = $window.width();
	    if (windowWidth !== resizeWidth) {
	      $("body").addClass("resizing");
	      if (timer > 0) {
	        clearTimeout(timer);
	      }
	      timer = setTimeout(function () {
	        $("body").removeClass("resizing");
	      }, 100);
	    }
	    windowWidth = resizeWidth;
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// headerPin
	// ------------------------------------------------------------------------
	var headerPin = function headerPin() {
	  $(window).on("load", function () {
	    var rate = windowWidth / windowHeight;
	    if (matchMedia('(min-width: 769px)').matches && rate > 1.43) {
	      // if (matchMedia('(min-width: 1301px)').matches && rate > 1.43) {
	      ScrollTrigger.create({
	        trigger: '.st-Header',
	        pin: '.st-Header_Bar',
	        end: 'bottom bottom'
	      });
	    }
	  });
	};
	
	// // ------------------------------------------------------------------------
	// // kv_animation
	// // ------------------------------------------------------------------------
	// const kv_animation = () => {
	//   let winScroll = $(window).scrollTop();
	//   let winHeight = $(window).height();
	//   // js-Animation
	//   $('.js-Animation-kv').each(function(){
	//     let target = $(this);
	//     target.addClass('animated');
	//   });
	// };
	
	// ------------------------------------------------------------------------
	// js-Animation
	// ------------------------------------------------------------------------
	var scrollAnimation = function scrollAnimation() {
	  var winScroll = $(window).scrollTop();
	  var winHeight = $(window).height();
	  // js-Animation
	  $('.js-Animation').each(function () {
	    var target = $(this);
	    if (target.offset().top < winScroll + winHeight * .9) {
	      target.addClass('animated');
	    }
	  });
	};
	
	/*-------------------------------------------------------------------*/
	/* movieモーダル */
	/*-------------------------------------------------------------------*/
	// movie
	var showMovie = function showMovie() {
	  var $modal = $('#movie-Stage');
	  var $content = $('#movie-Iframe');
	
	  // open
	  $('body').on('click', '.js-Youtube', function () {
	
	    var dataID = $(this).attr('data-youtube');
	
	    $('#movie-Stage').css({ 'opacity': '0', 'display': 'block' }).stop().animate({ 'opacity': '1', 'width': 100 + '%', 'height': 100 + 'vh', 'top': 0, 'left': 0 }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	      // // fadeIn
	      // $modal.stop().fadeIn(400);
	      return false;
	    });
	  });
	
	  //close
	  $('#movie-Close,#movie-Iframe').on('click', function () {
	
	    $('#movie-Stage').css({ 'opacity': '1' }).stop().animate({ 'opacity': '0' }, 300, 'easeOutQuart', function () {
	      $('#movie-Stage').css({ 'display': 'none' });
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	// ------------------------------------------------------------------------
	// headerToggle
	// ------------------------------------------------------------------------
	var headerToggle = function headerToggle() {
	  var $header = $('.st-Header');
	  // const $header_btn = $('.st-Header .st-Header_Hamburger');
	  var $header_btn = $('.st-Header .st-Header_Menu');
	  var $header_link = $('.st-Header a[href^=#]');
	  // const $header_link = $('.st-Header a[href^="#"]');
	  $header_btn.on('click', function () {
	    $header.toggleClass('active');
	    // $('body').toggleClass('noscrollBar');
	  });
	  $header_link.click(function () {
	    $header.removeClass('active');
	    // $('body').removeClass('noscrollBar');
	    return false;
	  });
	};
	
	//export
	exports.preload = preload;
	exports.resizing = resizing;
	exports.anchorScroll = anchorScroll;
	exports.scrollAnimation = scrollAnimation;
	exports.showMovie = showMovie;
	exports.headerPin = headerPin;
	exports.headerToggle = headerToggle;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// music/app.bundle.js